// extracted by mini-css-extract-plugin
export default {"root":"+agyw","row":"wwZ1u","text":"_3IPZm","date":"dM+bQ","total":"AQvdC","arrow":"McHsl"};